<template>
	<div>
		<vxe-modal v-model="modal_model" :title="detailTitle" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		<statistics :data="orderdata" ref="statistics" />
		<edit-index :row="currentrow" ref="editIndex" @success="submit" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import statistics from '../statistics/index.vue'
	import editIndex from './edit/index.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return null
				}
			},
			type: {
				default: () => {
					return 'unpay'
				}
			},
			detailTitle: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {

				modal_width:1200,
				modal_height:600,
				list_autorender:false,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}],
				orderdata: [],
				currentrow:null,
				columns:[],
				toolbarButton:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init(){
				let list_columns =  [{
					field: 'paymentcode',
					title: '单据编码',
				}, {
					field: 'corpCode',
					title: '账号代码'
				}, {
					field: 'suppliername',
					title: '供应商'
				}, {
					field: 'accName',
					title: '付款公司',
					filters: this.accNamefilters()
				}, {
					field: 'bankAcc',
					title: '付款账号',
					filters: this.bankAccfilters()
				}, {
					field: 'rcvName',
					title: '收款公司/人'
				}, {
					field: 'rcvAcc',
					title: '收款账号'
				}, {
					field: 'rcvBankName',
					title: '开户行'
				}, {
					field: 'needamount',
					title: '应付金额'
				}, 
				// {
				// 	field: 'checkstaffid',
				// 	title: '核对人',
				// 	filters: this.checkfilters(),
				// 	slots: {
				// 		default: ({
				// 			row
				// 		}) => {
				// 			return window.systemMethods.getstaff(row.checkstaffid)
				// 		},
				// 	}
				// },
				]
				let list_toolbarButton = [{
					code: 'export',
					name: '导出',
					status: "success"
				},{
					code: 'statistics',
					name: '统计',
					status: "primary"
				}]
				if(this.type=='unpay'){
					this.modal_title = '付款详情：' + this.data.date				
					list_toolbarButton.push({
							code: 'payment',
							name: '批量付款',
							status: "danger"
					})
					list_columns.unshift({
						type: 'checkbox',
						width: 60
					})	
					list_columns.push({
						title: '操作',
						fixed: "right",
						align: 'center',
						slots: {
							default: ({
								row
							}) => {
								return <el-button type="text" size="mini" onClick={()=>{this.payment(row)}}>付款</el-button>
							},
						}
					})
				}
				// if(this.type=='audit'){
				// 	this.modal_title = '待审核详情'
				// 	list_columns.push({
				// 		title: '操作',
				// 		fixed: "right",
				// 		align: 'center',
				// 		slots: {
				// 			default: ({
				// 				row
				// 			}) => {
				// 				return <el-button type="text" size="mini" onClick={()=>{this.ddcode(row)}}>凭证</el-button>
				// 			},
				// 		}
				// 	})
				// }	
				if(this.type=='pay'){
					this.modal_title = '已付款详情'
					list_columns.push({
						field: 'ddcode',
						title: '钉钉编码',
						width:200,
						fixed:'right'
					})
				}	
				if(this.type=='unpaypreview'){
					this.modal_title = '未付款详情'
					list_columns.push({
						field: 'ddcode',
						title: '钉钉编码',
						width:200,
						fixed:'right'
					})
				}	
				this.columns = list_columns
				this.toolbarButton = list_toolbarButton
				this.list_init()
				
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = this.columns
				gridOptions.toolbarConfig.buttons = this.toolbarButton
				gridOptions.formConfig = false
				gridOptions.scrollY = {
					enabled:false
				}
			},
			list() {	
				return new Promise((resolve) => {
					resolve({
						list: this.data.data
					})
				})
			},

			accNamefilters() {
				//console.log(this.data,123123)
				if (!this.data) {
					return []
				}
				let data = this.data.data
				let accNamefilters = []
				data.forEach((item) => {
					let index = accNamefilters.findIndex((_item) => {
						return _item.value == item.accName
					})
					if (index == -1) {
						accNamefilters.push({
							label: item.accName,
							value: item.accName
						})
					}
				})
				return accNamefilters
			},
			bankAccfilters() {
				//console.log(this.data,123123)
				if (!this.data) {
					return []
				}
				let data = this.data.data
				let bankAccfilters = []
				data.forEach((item) => {
					let index = bankAccfilters.findIndex((_item) => {
						return _item.value == item.bankAcc
					})
					if (index == -1) {
						bankAccfilters.push({
							label: item.bankAcc,
							value: item.bankAcc
						})
					}
				})
				return bankAccfilters
			},
			checkfilters() {
				if (!this.data) {
					return []
				}
				let data = this.data.data
				let checkfilters = []
				data.forEach((item) => {
					let index = checkfilters.findIndex((_item) => {
						return _item.value == item.checkstaffid
					})
					if (index == -1) {
						checkfilters.push({
							label: window.systemMethods.getstaff(item.checkstaffid),
							value: item.checkstaffid
						})
					}
				})
				return checkfilters
			},
			statistics() {
				this.orderdata = this.data.data
				this.$refs.statistics.modal_show()
			},
			payment(row) {
				let ids = []
				if (row && row.id) {
					ids.push(row.id)
				} else {
					let data = this.$refs.orderdetail.getCheckboxRecords()
					data.forEach((item) => {
						if (item.id) {
							ids.push(item.id)
						}
					})
				}
				if (ids.length == 0) {
					this.$message.error('请选择单据')
				} else {
					this.$confirm('是否确认付款','提示').then(()=>{
						this.$api.reconciliation_pay.payment({
							ids: ids
						}).then(() => {
							this.$message.success('操作成功')
							this.tableData.forEach((item) => {
								let index = ids.findIndex((id) => {
									return id == item.id
								})
								if (index !== -1) {
									this.$refs.orderdetail.remove(item)
								}
							})
						})
					})	
				}
			},
			ddcode(row){
				this.currentrow = row
				this.$refs.editIndex.modal_show()
			},
			submit(){
				this.$refs.orderdetail.remove(this.currentrow)
			}
		},
		components: {
			statistics,
			editIndex
		}
	}
</script>